<template>
  
  <div align="center">
    <v-icon color="primary" class="pa-5" size="100">do_not_disturb_alt</v-icon>
    <h1 class="primary--text">{{ $t("utils:error.pathForbidden.title") }}</h1>

    <div class="grey--text text--darken-2">
      {{ $t("utils:error.pathForbidden.body-1") }}
      <br/>
      {{ $t("utils:error.pathForbidden.body-2") }}
    </div>
  </div>
</template>

<script>

export default {
  
};


</script>
